import { ImageOff } from 'lucide-react';

import type { ProductListItem } from '@nucleus-commerce/api-client/admin';

/** A list row's image, already resolved by the list endpoint. */
export function ProductThumb({ image }: { image: ProductListItem['featuredImage'] }) {
  if (image) {
    return (
      <img
        src={image.url}
        alt={image.alt ?? ''}
        loading="lazy"
        className="size-10 shrink-0 rounded-md border object-cover"
      />
    );
  }
  return (
    <span className="text-muted-foreground bg-muted flex size-10 shrink-0 items-center justify-center rounded-md border border-dashed">
      <ImageOff aria-hidden className="size-4" />
    </span>
  );
}
